<template>
  <div class="row">
    <div class="hot-event-top">
      <ListHeader :title="'一周热门事件'" :isShowTab="false"></ListHeader>
      <div class="home-hot-event">
        <HomeHotEvent></HomeHotEvent>
      </div>
      <div class="event-footer">
        <ListFooter :show-name="!!id" class="footer" :footerName="'查看完整事件'" :locationData="'left'" @seeMore="seeMoreMonitor"></ListFooter>
      </div>
    </div>
    <div class="hot-event-list" v-loading="isLoading">
      <HomeEventList :data="homeEventListData"></HomeEventList>
      <div class="no-data-container" v-if="!homeEventListData.length && !isLoading">
        <no-data></no-data>
      </div>
      <ListFooter :show-name="homeEventListData.length > 3" :footerName="'查看完整排行'" :locationData="'right'" @seeMore="seeMoreMonitorList"></ListFooter>
    </div>
  </div>
</template>

<script>
import ListHeader from '@/components/common/ListHeader';
import HomeHotEvent from '@/components/news-monitor/HomeHotEvent';
import HomeEventList from '@/components/news-monitor/HomeEventList';
import ListFooter from '@/components/common/ListFooter';
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';
import NoData from '@/components/common/NoData';

export default {
  data() {
    return {
      name: '',
      id: '',
      isLoading: false,
      homeEventListData: [],
      timer: null
    };
  },
  methods: {
    seeMoreMonitor() {
      this.$router.push({
        name: 'event-detail',
        query: {
          name: this.name,
          id: this.id
        }
      });
    },
    seeMoreMonitorList() {
      this.$router.push({
        name: 'event-list',
        query: {
          name: this.name,
          source: 'home'
        }
      });
    },
    getHomeHotEventsData() {
      QuestionQuery.homeHotEvents(this.username).then(res => {
        this.isLoading = false;
        this.homeEventListData = res.other;
        this.name = res.topOne.title;
        this.id = res.topOne.id;
      }); 
    },
    getHomeHotEvents() {
      this.isLoading = true;
      this.getHomeHotEventsData();
    }
  },
  components: {
    ListHeader,
    HomeHotEvent,
    HomeEventList,
    ListFooter,
    NoData
  },
  mounted() {
    this.username = authService.getLoggedUserName();
    this.getHomeHotEvents();
    this.timer = window.setInterval(() => {
      this.getHomeHotEventsData();
    }, 1000 * 60);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);        
    }
  }
};
</script>

<style lang="scss" scoped>
.hot-event-top {
  flex: 2;
  height: 349px;
  overflow: hidden;
  border-top-left-radius: 8px;
  .home-hot-event {
    height: 225px;
    background-color: #3e3c42;
  }
  .event-footer {
    padding: 24px 0 8px;
    border-bottom-left-radius: 8px;
    background-color: #3e3c42;
  }
}
.hot-event-list {
  position: relative;
  flex: 1;
  margin-left: 1px;
  overflow: hidden;
  border-bottom-right-radius: 8px;
  border-top-right-radius: 8px;
  .no-data-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .no-data {
      font-size: 18px;
    }
  }
}
</style>

